import RestService from '../RestService';
import * as React from 'react';
import Snackbar from 'material-ui/Snackbar';

import '../styles/style.css';

interface Props {
    history?: any;
}

interface State {
    selectedFile: any;
    selectedFileSize: number;
    snackbarMessage: string;
    openSnackbar: boolean;
}

class UploadCsvComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedFile: null,
            selectedFileSize: 0,
            snackbarMessage: 'Progress Updates will come here',
            openSnackbar: true,
        };
    }

    fileSelectedHandler = event =>{
        this.setState({
            ...this.state,
            selectedFile: event.target.files[0],
            selectedFileSize: event.target.files[0].size,
            openSnackbar: false,
        });
    }

    fileUploadHandler = () =>{
        if (this.state.selectedFile == null) {
            this.setState({
                ...this.state,
                openSnackbar: true,
                snackbarMessage: 'Please Choose a csv file to upload.',
            });
        }
        else {
            if (this.state.selectedFileSize > 0 && this.state.selectedFileSize <= 94371840) {
                console.log('File Size', this.state.selectedFileSize);
                     RestService.uploadCsv(this.state.selectedFile);
                     this.setState({
                         ...this.state,
                         openSnackbar: true,
                         snackbarMessage: 'CSV uploaded.',
                     });
                 }
            else{
                this.setState({
                    ...this.state,
                    openSnackbar: true,
                    snackbarMessage: 'CSV upload failed. File Size Greater than 90 MB',
                });
            }
        }
    }

    render() {
        return (
            <div className='center'>
                <h1>Upload CSV</h1>
                <div className='upload'><input type='file' accept='.csv' onChange={this.fileSelectedHandler}/></div>
                <div><button onClick={this.fileUploadHandler}> Click to Upload </button></div>
                <div className='info'>Maximum file size 5 MB. Valid Only For 365 Days.</div>
                <Snackbar open={this.state.openSnackbar} message={this.state.snackbarMessage} autoHideDuration={2000}/>
            </div>
        );
    }
}

export default UploadCsvComponent;



// WEBPACK FOOTER //
// ./src/components/UploadCsv.tsx